import styled from "styled-components";

export const FormHeading = styled.h2`
  margin: 0.5rem 0 2rem 0;
  position: relative;
  color: var(--dark-gray);
  padding-bottom: 0.2rem;
  &:after {
    content: "";
    position: absolute;
    top: 100%;
    left: 0;
    height: 6px;
    border-radius: 2rem;
    width: 150px;
    background: var(--main-color);
  }
`;
